module.exports = {"220104001":"前进街道","220104002":"桂林街道","220104003":"南湖街道","220104004":"永昌街道","220104005":"重庆街道","220104006":"清和街道","220104007":"红旗街道","220104008":"湖西街道","220104009":"富锋街道","220104100":"乐山镇","220104101":"永春镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220104.json
// module id = 693
// module chunks = 0